import I18n from 'apps/new-web/views/components/i18n';

const errors = {
  EMPTY_EMAIL: I18n.translate('Please enter an email or username.'),
  EMPTY_PASSWORD: I18n.translate('Please enter a password.')
};

export const validateEmail = (email) => {
  if (!email) return errors.EMPTY_EMAIL;
};

export const validatePassword = (password) => {
  if (!password) return errors.EMPTY_PASSWORD;
};

export const validateFields = values => ({
  email: validateEmail(values.email),
  password: validatePassword(values.password)
});
